import React, { useState, useEffect } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { H1Heading, Subheading as SubheadingBase } from "../../content/misc/Headings.js";
import { SectionDescription } from "../../content/misc/Typography.js";
import client from 'sanityClient';
import { useLanguage } from "../../helpers/languageSelector.js";


const Container = tw.div`relative`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-lg mx-auto py-6 md:py-8`}
`;
const Subheading = tw(SubheadingBase)`mb-4`;
const Heading = tw(H1Heading)`w-full text-4xl sm:text-5xl`;
const Description = tw(SectionDescription)`w-full text-center`;

const VerticalSpacer = tw.div`mt-10 w-full`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 max-w-sm`}
`;

const Card = styled.div`
  ${tw`flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left h-full mx-4 px-2 py-8`}
  .imageContainer {
    ${tw`border text-center rounded-full p-5 flex-shrink-0`}
    img {
      ${tw`w-6 h-6`}
    }
  }

  .textContainer {
    ${tw`sm:ml-4 mt-4 sm:mt-2`}
  }

  .title {
    ${tw`mt-4 tracking-wide font-bold text-2xl leading-none`}
  }

  .description {
    ${tw`mt-1 sm:mt-4 font-medium text-secondary-100 leading-loose`}
  }
`;

const HEADING_FALLBACKS = {
  nl: "Verzekeringsdiensten",
  en: "Insurance Services",
  de: "Versicherungsleistungen",
};

const SUBHEADING_FALLBACKS = {
  nl: "Ondersteuning",
  en: "Support",
  de: "Support",
};

const DEFAULT_CARDS = {
  en: [
    {
      title: "Submit a claim",
      description: "If you want to file a claim with Europeesche Verzekeringen, you can do this in 2 ways:\n– Online via the claims forum\n– By telephone during office hours via telephone number 020-651 52 53\n\nWhen reporting your claim, keep the invoices, warranty certificates, statements and other evidence at hand. The more completely you describe your damage and add evidence, the faster Europeesche Verzekeringen can settle your claim."
    },
    {
      title: "Help in your pocket app",
      description: "The free Help in Pocket app from Europeesche Verzekeringen offers you important medical information about your (future) holiday destination. The app is equipped with an extensive medical source of information and a medical dictionary in 9 languages. You can also find the numbers of all Dutch emergency centers in this app."
    },
    {
      title: "Problems on holiday",
      description: "You go on holiday to enjoy yourself. If something goes wrong, you can call the Europeesche Helpline worldwide, day and night. The employees of the Europeesche Helpline will answer your questions in the event of breakdowns, accidents, illness and emergencies. If you need a doctor, they will refer you to a reliable specialist or a good hospital near you. If necessary, they immediately call the SOS International emergency center for help."
    },
    {
      title: "Europeesche Helpline",
      description: "The Europeesche Helpline can be reached via +31-20 65 15 777 \n Have your booking number and the telephone number where you can be reached at hand when you contact the Europeesche Helpline. We recommend that you save the European Helpline number in your mobile phone. Then you always have the number at hand in case of an emergency."
    },
    {
      title: "Tips in case of damage, loss or theft",
      description: "If your luggage is damaged or lost during the holiday, it is important that you have a statement drawn up by our tour guide. It is also important that you always report loss or theft to the local police. Always ask for written proof of this.\n\nKeep your damaged items, invoices and statements in a safe place. It is possible that Europeesche Verzekeringen will ask you to send this at a later stage."
    }
  ],
  nl: [
    {
      title: "Schade melden",
      description: "Wil je een schade melden bij Europeesche Verzekeringen, dan kan dat op 2 manieren:\n– Online via het schadeportaal\n– Telefonisch tijdens kantooruren via 020-651 52 53\n\nHoud bij het melden facturen, garantiebewijzen, verklaringen en ander bewijs bij de hand. Hoe vollediger je de schade beschrijft en bewijsstukken toevoegt, hoe sneller Europeesche Verzekeringen de schade kan afhandelen."
    },
    {
      title: "Help in Pocket-app",
      description: "De gratis Help in Pocket-app van Europeesche Verzekeringen biedt belangrijke medische informatie over je (toekomstige) vakantiebestemming. De app bevat een uitgebreide medische informatiebron en een medisch woordenboek in 9 talen. Je vindt er ook de nummers van alle Nederlandse alarmcentrales."
    },
    {
      title: "Problemen op vakantie",
      description: "Je gaat op vakantie om te genieten. Gaat er iets mis, bel dan wereldwijd dag en nacht de Europeesche Helpline. Medewerkers beantwoorden vragen bij pech, ongelukken, ziekte en noodgevallen. Heb je een arts nodig, dan verwijzen zij je naar een betrouwbare specialist of een goed ziekenhuis in de buurt. Indien nodig schakelen zij direct SOS International in."
    },
    {
      title: "Europeesche Helpline",
      description: "De Europeesche Helpline is bereikbaar via +31-20 65 15 777.\nHoud je boekingsnummer en het telefoonnummer waarop je bereikbaar bent bij de hand. Sla het nummer van de Europeesche Helpline op in je telefoon, zodat je het in noodgevallen altijd bij de hand hebt."
    },
    {
      title: "Tips bij schade, verlies of diefstal",
      description: "Is je bagage beschadigd of zoekgeraakt tijdens de vakantie? Laat dan een verklaring opstellen door onze reisbegeleider. Meld verlies of diefstal altijd bij de lokale politie en vraag om schriftelijk bewijs.\n\nBewaar beschadigde spullen, facturen en verklaringen goed. Europeesche Verzekeringen kan later vragen deze op te sturen."
    }
  ],
  de: [
    {
      title: "Schaden melden",
      description: "Möchten Sie einen Schaden bei Europeesche Verzekeringen melden, geht das auf 2 Arten:\n– Online über das Schadenportal\n– Telefonisch während der Bürozeiten unter 020-651 52 53\n\nHalten Sie bei der Meldung Rechnungen, Garantienachweise, Erklärungen und andere Belege bereit. Je vollständiger Sie den Schaden beschreiben und Belege beifügen, desto schneller kann Europeesche Verzekeringen den Schaden bearbeiten."
    },
    {
      title: "Help in Pocket-App",
      description: "Die kostenlose Help in Pocket-App von Europeesche Verzekeringen bietet wichtige medizinische Informationen zu Ihrem (zukünftigen) Reiseziel. Die App enthält eine umfangreiche medizinische Informationsquelle und ein medizinisches Wörterbuch in 9 Sprachen. Sie finden dort auch die Nummern aller niederländischen Notrufzentralen."
    },
    {
      title: "Probleme im Urlaub",
      description: "Sie fahren in den Urlaub, um zu genießen. Wenn etwas schiefgeht, rufen Sie rund um die Uhr weltweit die Europeesche Helpline an. Die Mitarbeiter beantworten Fragen bei Panne, Unfall, Krankheit und Notfällen. Wenn Sie einen Arzt brauchen, vermitteln sie einen zuverlässigen Spezialisten oder ein gutes Krankenhaus in der Nähe. Bei Bedarf schalten sie sofort SOS International ein."
    },
    {
      title: "Europeesche Helpline",
      description: "Die Europeesche Helpline erreichen Sie unter +31-20 65 15 777.\nHalten Sie Ihre Buchungsnummer und die Telefonnummer bereit, unter der Sie erreichbar sind. Speichern Sie die Nummer der Europeesche Helpline in Ihrem Handy, damit Sie sie im Notfall immer griffbereit haben."
    },
    {
      title: "Tipps bei Schaden, Verlust oder Diebstahl",
      description: "Ist Ihr Gepäck im Urlaub beschädigt oder verloren gegangen? Lassen Sie dann eine Erklärung durch unseren Reiseleiter erstellen. Melden Sie Verlust oder Diebstahl immer der örtlichen Polizei und verlangen Sie einen schriftlichen Nachweis.\n\nBewahren Sie beschädigte Gegenstände, Rechnungen und Erklärungen sicher auf. Europeesche Verzekeringen kann später darum bitten, diese einzusenden."
    }
  ],
};

const InsuranceCards = () => {
  const { currentLanguage } = useLanguage();
  const [data, setData] = useState({
    subheading2: '',
    heading2: '',
    description2: '',
    cards: []
  });

  useEffect(() => {
    client.fetch(`*[_type == "insurance" && language == "${currentLanguage}"]`)
      .then((fetchedData) => {
        if (fetchedData.length > 0) {
          setData(fetchedData[0]);
        } else {
          setData({
            subheading2: '',
            heading2: '',
            description2: '',
            cards: []
          });
        }
      })
      .catch((error) => console.error('Error fetching data:', error));
  }, [currentLanguage]);

  const heading =
    data.heading2 ||
    HEADING_FALLBACKS[currentLanguage] ||
    HEADING_FALLBACKS.en;
  const subheading =
    data.subheading2 ||
    SUBHEADING_FALLBACKS[currentLanguage] ||
    SUBHEADING_FALLBACKS.en;
  const cards =
    data.cards && data.cards.length > 0
      ? data.cards
      : DEFAULT_CARDS[currentLanguage] || DEFAULT_CARDS.en;

  return (
    <Container>
      <ThreeColumnContainer>
        {subheading && <Subheading>{subheading}</Subheading>}
        <Heading>{heading}</Heading>
        {data.description2 && <Description>{data.description2}</Description>}
        <VerticalSpacer />
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="textContainer">
                <span className="title">{card.title || "Fully Secure"}</span>
                <p className="description">
                  {card.description || "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud."}
                </p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
    </Container>
  );
};

export default InsuranceCards;
